/* eslint-disable @typescript-eslint/camelcase */
import { HangingApiRepository } from "@/app/infrastructures/repositories/api/HangingApiRepository";
import {
  HangingLastMileSummary,
  HistoryFollowUpLastMileEntities,
  HistoryFollowUpLastMileRequest
} from "@/domain/entities/HangingLastMile";
import {
  HangingIncomingSummary,
  HangingIncomingFilterRequest,
  FilterRiwayatRequest,
  RiwayatHangingLasmileRequest,
  RiwayatHangingLasmileEntities,
  HangingIncoming,
  HistoryFollowUpIncomingRequest,
  HistoryFollowUpIncomingEntities,
  HangingLastMileFilterRequest,
  HistoryHangingIncomingFilterRequest,
  HistoryHangingIncomingEntities,
  HangingIncomingUpdateStatus,
  HistoryHanging
} from "@/domain/entities/HangingIncoming";
import { HangingLastMile } from "@/domain/entities/HangingLastMile";
import {
  HangingConfirmDonePosBkdPayload,
  HangingLastMileConfirmApiRequest,
  SubmitHangingConfirmationFollowUp,
  SubmitHangingConfirmationUpdateStatus
} from "@/data/payload/api/HangingApiRequest";
import { injectable } from "tsyringe";
import {
  HistoryFollowUpOutgoingFilterRequest,
  HistoryFollowUpOutgoingEntities,
  HangingOutgoingRequest,
  ConfirmHangingOutgoingRequest,
  DownloadHangingOutgoing,
  HangingBookingPosSummary
} from "@/domain/entities/HangingOutgoing";
import {
  HistoryHangingBookingFilterRequest,
  HistoryHangingBookingEntities,
  HistoryFollowUpBookingFilterRequest,
  HistoryFollowUpBookingEntities
} from "@/domain/entities/HangingBooking";
import {
  HangingList,
  HangingPosBkdListRequest
} from "@/domain/entities/Hanging";
import { HangingConsoleBkdListRequest, ConfirmHangingBkdConsole, DownloadHangingBkdConsole } from '@/domain/entities/HangingBkd';

@injectable()
export class SttHangingPresenter {
  private repository: HangingApiRepository;

  constructor(repository: HangingApiRepository) {
    this.repository = repository;
  }

  public getHangingIncomingSummary(): Promise<HangingIncomingSummary> {
    return this.repository.getHangingIncomingSummary();
  }

  public getHangingLastMileSummary(): Promise<HangingLastMileSummary> {
    return this.repository.getHangingLastMileSummary();
  }

  public getHangingIncoming(
    params: HangingIncomingFilterRequest
  ): Promise<HangingIncoming[]> {
    return this.repository.getHangingIncoming(params);
  }

  public getHangingLastMile(
    params: HangingLastMileFilterRequest
  ): Promise<HangingLastMile[]> {
    return this.repository.getHangingLastMile(params);
  }

  public getFilterRiwayat(
    params: FilterRiwayatRequest
  ): Promise<HangingIncomingSummary> {
    return this.repository.getFilterRiwayat(params);
  }
  public submitHangingConfirmationFollowUp(
    payload: SubmitHangingConfirmationFollowUp
  ): Promise<void> {
    return this.repository.submitHangingConfirmationFollowUp(payload);
  }

  public submitHangingConfirmationUpdateStatus(
    payload: SubmitHangingConfirmationUpdateStatus
  ): Promise<HangingIncomingUpdateStatus> {
    return this.repository.submitHangingConfirmationUpdateStatus(payload);
  }

  public hangingLastMileConfirmFollowUp(
    payload: HangingLastMileConfirmApiRequest
  ): Promise<void> {
    return this.repository.hangingLastMileConfirmFollowUp(payload);
  }

  public getRiwayatHangingLastmile(
    params: RiwayatHangingLasmileRequest
  ): Promise<RiwayatHangingLasmileEntities> {
    return this.repository.getRiwayatHangingLastmile(params);
  }

  public downloadHangingIncoming(listStt: []): Promise<void> {
    return this.repository.downloadHangingIncoming(listStt);
  }

  public downloadHangingLasMile(listStt: []): Promise<void> {
    return this.repository.downloadHangingLastMile(listStt);
  }

  public getHistoryFollowUpIncoming(
    params: HistoryFollowUpIncomingRequest
  ): Promise<HistoryFollowUpIncomingEntities> {
    return this.repository.getHistoryFollowUpIncoming(params);
  }

  public getHistoryFollowUpLastMile(
    params: HistoryFollowUpLastMileRequest
  ): Promise<HistoryFollowUpLastMileEntities> {
    return this.repository.getHistoryFollowUpLastMile(params);
  }

  public getHistoryHangingIncoming(
    params: HistoryHangingIncomingFilterRequest
  ): Promise<HistoryHangingIncomingEntities> {
    return this.repository.getHistoryHangingIncoming(params);
  }

  public getHangingOutgoingSummary() {
    return this.repository.getHangingOutgoingSummary();
  }

  public getHistoryHangingOutgoing(
    params: HistoryHangingIncomingFilterRequest
  ): Promise<HistoryHanging> {
    return this.repository.getHistoryHangingOutgoing(params);
  }

  public getHistoryFollowUpOutgoing(
    params: HistoryFollowUpOutgoingFilterRequest
  ): Promise<HistoryFollowUpOutgoingEntities> {
    return this.repository.getHistoryFollowUpOutgoing(params);
  }

  public getHangingOutgoing(params: HangingOutgoingRequest) {
    return this.repository.getHangingOutgoing(params);
  }

  public confirmHangingOutgoing(payload: ConfirmHangingOutgoingRequest) {
    return this.repository.confirmHangingOutgoing(payload);
  }

  public downloadHangingOutgoing(payload: DownloadHangingOutgoing) {
    return this.repository.downloadHangingOutgoing(payload);
  }

  public getHistoryHangingBooking(
    params: HistoryHangingBookingFilterRequest
  ): Promise<HistoryHangingBookingEntities> {
    return this.repository.getHistoryHangingBooking(params);
  }

  public getHangingBookingPosSummary(): Promise<HangingBookingPosSummary> {
    return this.repository.getHangingBookingPosSummary();
  }

  public getHistoryFollowUpBooking(
    params: HistoryFollowUpBookingFilterRequest
  ): Promise<HistoryFollowUpBookingEntities> {
    return this.repository.getHistoryFollowUpBooking(params);
  }

  public getHangingPosBkd(
    params: HangingPosBkdListRequest
  ): Promise<HangingList[]> {
    return this.repository.getHangingPosBkd(params);
  }

  public donwloadHangingPosBkd(listStt: []): Promise<void> {
    return this.repository.donwloadHangingPosBkd(listStt);
  }

  public confirmDoneHangingPosBkd(
    payload: HangingConfirmDonePosBkdPayload
  ): Promise<void> {
    return this.repository.confirmDoneHangingPosBkd(payload);
  }

  public getHangingConsoleBkdSummary() {
    return this.repository.getHangingConsoleBkdSummary();
  }

  public getHangingConsoleBkdList(params: HangingConsoleBkdListRequest) {
    return this.repository.getHangingConsoleBkdList(params);
  }

  public confirmHangingBkdConsole(payload: ConfirmHangingBkdConsole) {
    return this.repository.confirmHangingBkdConsole(payload);
  }

  public downloadHangingBkdConsole(payload: DownloadHangingBkdConsole) {
    return this.repository.downloadHangingBkdConsole(payload);
  }
}